var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { archiveTaskRequest, deleteTaskRequest, markTaskDoneRequest, removeTaskFromUserRequest, restoreArchivedTaskRequest, } from "../../api/api";
const useTaskActions = () => {
    const deleteTask = (taskId, callback) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield deleteTaskRequest(taskId);
            if (callback)
                callback();
            toast.success(__("Task deleted", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to delete a task", "quicktasker"));
        }
    });
    const archiveTask = (taskId, callback) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield archiveTaskRequest(taskId);
            if (callback)
                callback();
            toast.success(__("Task archived", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to archive a task", "quicktasker"));
        }
    });
    const restoreArchivedTask = (taskId, callback) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield restoreArchivedTaskRequest(taskId);
            if (callback)
                callback();
            toast.success(__("Task restored", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to restore a task", "quicktasker"));
        }
    });
    const removeTaskFromUser = (userId, taskId, callback) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield removeTaskFromUserRequest(userId, taskId);
            if (callback)
                callback();
            toast.success(__("Task has been unassigned", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("Task unassignment failed. Try again", "quicktasker"));
        }
    });
    const changeTaskDoneStatus = (taskId, isCompleted, callback) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const successMessage = isCompleted
                ? __("Task marked as completed", "quicktasker")
                : __("Task marked as incomplete", "quicktasker");
            yield markTaskDoneRequest(taskId, isCompleted);
            if (callback)
                callback(isCompleted);
            toast.success(successMessage);
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to change task status", "quicktasker"));
        }
    });
    return {
        deleteTask,
        archiveTask,
        restoreArchivedTask,
        removeTaskFromUser,
        changeTaskDoneStatus,
    };
};
export { useTaskActions };
